import "./CopyTextControl.scss";
import { copyLink } from "utils/share";

export const CopyTextControl = (props: {
  value: string;
  onClick?: () => void;
}): JSX.Element => {
  const onClick = async () => {
    await copyLink(props.value);

    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <div className="copyControl">
      <input type="text" readOnly value={props.value} />
      <button onClick={onClick}>Copy</button>
    </div>
  );
};
